export default __webpack_public_path__ + "static/media/trr-drink-coffee-batchcoffee.c987e753.png";